'use strict';

import React, { Component } from 'react';

const InfoComponent = props => (
  <div
    className="map-menu__panel map-menu__panel--active"
    dangerouslySetInnerHTML={{ __html: props.htmlContent }}>
  </div>
);

export default InfoComponent;
